// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__i7H6N"};